export const LOAD_LISTING = "LOAD_LISTING";
export const START_LOADING = "START_LOADING";
export const REMOVE_LISTINGS = "REMOVE_LISTINGS";
export const LOAD_SERVICE_LISTING = "LOAD_SERVICE_LISTING";
export const LOADING_SERVICE_LISTING = "LOADING_SERVICE_LISTING";
export const ERROR_LOAD_SERVICE_LISTING = "ERROR_LOAD_SERVICE_LISTING";
export const ERROR_LOAD_LISTING = "ERROR_LOAD_LISTING";
